import { render } from "./FolderShared.vue?vue&type=template&id=7579ed90"
import script from "./FolderShared.vue?vue&type=script&lang=js"
export * from "./FolderShared.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__